module.exports = __webpack_public_path__ + "static/hacktober-fest-cover-image-5e32f5e15bf1d3ec5292a5764c9f1abe.webp";